export default __webpack_public_path__ + "static/media/b8-med.1aaf7509.jpg";